import { ReactNode } from "react";

// Az interfész neve és a propok is a textarea igényeihez igazodnak
interface TextareaFieldProps {
  name:string;
  value?:string;
  placeholder?:string;
  icon?:ReactNode;
  disabled?:boolean;
  hasError?:boolean;
  rows?:number; // <-- Új, opcionális prop a sorok számának beállításához
  onChange?:(value:string) => void;
}

const TextareaField:React.FunctionComponent<TextareaFieldProps> = ({
  name,
  value,
  icon,
  disabled,
  placeholder,
  hasError,
  rows = 4, // Alapértelmezett érték a sorok számának
  onChange,
}) => {
  // Az esemény típusát `HTMLTextAreaElement`-re kell cserélni
  const handleChange = (event:React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div className="relative">
      {icon && (
        // Az ikon pozicionálása a textarea mellett CSS igazítást igényelhet
        <div className={`input-icon ${disabled ? "disabled" : ""} ${hasError ? "error" : ""}`}>
          {icon}
        </div>
      )}

      <textarea
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        className={`input-field ${hasError ? "error" : ""}`}
        value={value}
        onChange={handleChange}
        rows={rows} // A textarea magasságát beállító prop
      />
    </div>
  );
};

export default TextareaField;